import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-regular-medicine.reducer';

export const DoctorRegularMedicineDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorRegularMedicineEntity = useAppSelector(state => state.doctorRegularMedicine.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorRegularMedicineDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.detail.title">DoctorRegularMedicine</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.id}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.cursor}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{doctorRegularMedicineEntity.createdBy}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorRegularMedicineEntity.doctor ? doctorRegularMedicineEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorRegularMedicine.medicine">Medicine</Translate>
          </dt>
          <dd>{doctorRegularMedicineEntity.medicine ? doctorRegularMedicineEntity.medicine.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-regular-medicine" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-regular-medicine/${doctorRegularMedicineEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorRegularMedicineDetail;
